import script from "./jobCategories.vue?vue&type=script&setup=true&lang=ts"
export * from "./jobCategories.vue?vue&type=script&setup=true&lang=ts"

import "./jobCategories.vue?vue&type=style&index=0&id=b6f48fe2&lang=scss"

const __exports__ = script;

export default __exports__